import { enrollBuilding, LegalEntityApiError } from "@/lib/legalEntityApi";

export type EnrollCleaningLocationParams = {
  orgId: string;
  address: string;
  googlePlaceId: string;
  latitude: number | null;
  longitude: number | null;
  legalEntityId?: string | null;
};

export type EnrollCleaningLocationResult =
  | { status: "created"; contractorRecommended: boolean }
  | { status: "enrolled"; contractorRecommended: boolean }
  | { status: "duplicate"; address: string };

/**
 * Adds a building to Cleaning. Contractor/NIP is optional
 * (private tenement is allowed). Duplicate community on one address is blocked.
 */
export async function enrollCleaningLocation(
  params: EnrollCleaningLocationParams
): Promise<EnrollCleaningLocationResult> {
  try {
    const result = await enrollBuilding({
      orgId: params.orgId,
      legalEntityId: params.legalEntityId ?? null,
      googlePlaceId: params.googlePlaceId,
      address: params.address.trim(),
      latitude: params.latitude,
      longitude: params.longitude,
      module: "cleaning",
    });

    if (result.status === "duplicate") {
      return { status: "duplicate", address: result.address };
    }

    return {
      status: result.status === "created" ? "created" : "enrolled",
      contractorRecommended: result.contractorRecommended,
    };
  } catch (err) {
    console.error("[enrollCleaningLocation]", err);
    if (err instanceof LegalEntityApiError) throw err;
    throw err;
  }
}
